export default () => ({
  stacktraceData: {},
  loadingStacktrace: true,
  updatingResolveStatus: false,
  updatingIgnoreStatus: false,
  errorStatus: '',
});
